<template>
  <v-list-item
    class="app-menu-item"
    :class="item.style"
    :data-locator="item.locatorValue"
    :disabled="item.loading || item.disabled"
    @click="$emit('itemClick', item)"
  >
    <v-progress-circular v-if="item.loading"
                         indeterminate
                         size="24"
                         class="mr-2"
    />
    <v-list-item-title class="d-flex align-center column-gap-2 text-text-secondary">
      <span class="d-flex align-center justify-center icon-wrapper">
        <template v-if="!iconAfter && item.icon">
          <app-material-icon
            :name="item.icon"
            size="sm"
            :color="item.iconColor ?? 'icon-primary'"
          />
        </template>
        <template v-if="item.iconComponent">
          <component :is="item.iconComponent" />
        </template>
      </span>
      <span v-html="item.title"></span>
      <template v-if="iconAfter && item.icon">
        <app-material-icon :name="item.icon" size="sm" color="inherit" />
      </template>
      <AppFeatureTag v-if="item.featureTag" size="sm" :tag="item.featureTag" class="ml-2" />
    </v-list-item-title>
  </v-list-item>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'

import AppFeatureTag from '@/common/AppFeatureTag.vue'
import type { MenuItemType } from '@/types/menu.d.ts'

export default defineComponent({
  name: 'AppMenuItem',
  components: { AppFeatureTag },
  props: {
    item: {
      type: Object as PropType<MenuItemType>,
      required: true,
    },
    iconAfter: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['itemClick'],
})
</script>

<style scoped lang="scss">
.icon-wrapper {
  height: 20px;
  width: 20px;
}

.app-menu-item {
  color: rgb(var(--v-theme-text-secondary))
}
</style>
